module.exports = __webpack_public_path__ + "static/img/6.a5e25f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/padImage/ppt/6.jpg
// module id = PZtu
// module chunks = 1